module.exports = "<mat-dialog-content>\n\t<p>\n\t\t{{message}}\n\t</p>\n</mat-dialog-content>\n<mat-dialog-actions align=\"center\">\n\t<button mat-raised-button color=\"primary\" (click)=\"onConfirmClick()\" tabindex=\"1\">{{confirmButtonText}}</button>\n\t<button mat-raised-button mat-dialog-close tabindex=\"-1\">{{cancelButtonText}}</button>\n</mat-dialog-actions>"


//////////////////
// WEBPACK FOOTER
// ./src/app/confirmation-dialog/confirmation-dialog.component.html
// module id = ./src/app/confirmation-dialog/confirmation-dialog.component.html
// module chunks = main